
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-security-and-privacy",
      function () {
        return require("private-next-pages/data-security-and-privacy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-security-and-privacy"])
      });
    }
  